import { SansText } from '../SansText/SansText'
import type { TextProps } from '../SansText/SansText.types'

export const HorizontalCardPrice = (
  props: Omit<TextProps, 'as' | 'size'>,
): JSX.Element => {
  return <SansText {...props} size="md" as="span" />
}
